import React from 'react';
import { Check } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '../utils/cn';

interface SelectionCardProps {
  icon: LucideIcon;
  title: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function SelectionCard({ icon: Icon, title, selected, onClick, disabled }: SelectionCardProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'relative p-6 rounded-xl border-2 transition-all duration-200',
        'flex flex-col items-center justify-center gap-3',
        'hover:shadow-lg hover:scale-105 active:scale-95',
        selected
          ? 'border-blue-600 bg-blue-50 shadow-md'
          : 'border-gray-200 bg-white hover:border-blue-300',
        disabled && !selected && 'opacity-50 cursor-not-allowed hover:scale-100'
      )}
    >
      {selected && (
        <div className="absolute top-2 right-2 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
          <Check className="w-4 h-4 text-white" />
        </div>
      )}

      <div className={cn(
        'w-12 h-12 rounded-full flex items-center justify-center transition-colors',
        selected ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-600'
      )}>
        <Icon className="w-6 h-6" />
      </div>

      <span className={cn(
        'text-base font-semibold transition-colors',
        selected ? 'text-blue-900' : 'text-gray-700'
      )}>
        {title}
      </span>
    </button>
  );
}
